import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.form.withInlineEditing.createForm.${key}`;
const CreateFormButton = ({
  hasPermission = false,
  onClick = () => {},
  use = 'tertiary'
}) => {
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('noWriteAccess')
    }),
    disabled: hasPermission,
    children: /*#__PURE__*/_jsx(Button, {
      "data-selenium": "create-resource-button",
      size: "sm",
      use: use,
      block: true,
      onClick: onClick,
      disabled: !hasPermission,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('label')
      })
    })
  });
};
export default CreateFormButton;